import { Input, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ParameterService } from '../../services/parameter.service';

@Component({
    selector: 'app-course-details-link',
    template: `<a target="_blank" href="{{url}}">{{name}}</a>`
})
export class CourseDetailsLinkComponent implements OnInit {
    @Input() code: string;
    @Input() name: string;

    url: string = '';

    constructor(private para: ParameterService) { }

    ngOnInit() {
        this.para.getValues().subscribe(data => {
            this.url = this.para.findValue(data, 'CourseDetailsUrl', t => t, '').replace('{SubjectCode}', this.code);
        });
    }
}
